/* shift source modes */
export const STAFF = 'S'
export const RESOURCE = 'R'

/* grid values */
export const TIME_SLOT_WIDTH = 7 // px
export const TIME_SLOT = 5 // minutes
export const SHIFTS_CONTENT_WIDTH = 84 * 24 // hours
export const DEFAULT_RESOURCE_HEIGHT = 77 // px
export const DEFAULT_OPENING_HOURS_HEIGHT_DAY = 52 // px
export const DEFAULT_OPENING_HOURS_HEIGHT_WEEK = 75 // px
export const DAY_SHIFT_SLOT_HEIGHT = 42 // px
export const DAY_SHIFT_SLOT_HEIGHT_OFFSET = 6 // px
export const DAY_SHIFT_SLOT_TOP = 17 // px
export const BREAK_SLOT_HEIGHT = 24 // px

/* default hours */
export const DEFAULT_HOUR_FROM = '10:00'
export const DEFAULT_HOUR_TILL = '19:00'
export const DEFAULT_INTERVAL = 5 // minutes
export const DEFAULT_OPENING_HOURS = [
  {
    day_of_week: 0,
    hours: [],
  },
  {
    day_of_week: 1,
    hours: [{
      hour_from: DEFAULT_HOUR_FROM,
      hour_till: DEFAULT_HOUR_TILL,
    }],
  },
  {
    day_of_week: 2,
    hours: [{
      hour_from: DEFAULT_HOUR_FROM,
      hour_till: DEFAULT_HOUR_TILL,
    }],
  },
  {
    day_of_week: 3,
    hours: [{
      hour_from: DEFAULT_HOUR_FROM,
      hour_till: DEFAULT_HOUR_TILL,
    }],
  },
  {
    day_of_week: 4,
    hours: [{
      hour_from: DEFAULT_HOUR_FROM,
      hour_till: DEFAULT_HOUR_TILL,
    }],
  },
  {
    day_of_week: 5,
    hours: [{
      hour_from: DEFAULT_HOUR_FROM,
      hour_till: DEFAULT_HOUR_TILL,
    }],
  },
  {
    day_of_week: 6,
    hours: [],
  },
]
